<div fxFill fxLayout="column" fxLayoutAlign="start center">
  <!-- HEADER -->
  <app-header-noauth
    [onfido]="true"
    class="appHeader appHeader--sticky appHeader--noauth"
    [hideLanguage]="true"
  ></app-header-noauth>
  <!-- BODY -->
  <div class="wrapper wrapper--noauth" fxLayoutAlign="center center" fxFlex="100%">
    <div fxFlex="100" class="wrapper__content">
      <mat-card fxFlex="100">
        <div class="content">
          <ng-container *ngIf="!errorMessage">
            <h1 translate>videoselfing.finish.title</h1>
          </ng-container>

          <ng-container *ngIf="errorMessage">
            <h2 translate>videoselfing.error.process</h2>
          </ng-container>
        </div>
      </mat-card>
    </div>
  </div>
</div>
